import { MainLoadingView } from './ChartLoadingSkeleton';

export function AppLaunchScreen() {
  return <MainLoadingView label="Loading Chartify" />;
}
